import { getUrl, parseItemAncestorsFromUrlCommon } from './common';

const routes = {
  url: getUrl,
  parseItemAncestorsFromUrl: parseItemAncestorsFromUrlCommon,
};
export default routes;
